module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-20.dec1d4bd.jpg";